/**
 * Sticky Scroll Script для Known Player
 *
 * Логика:
 * 1. Следим за скроллом
 * 2. Когда низ viewport касается НИЗА блока .product__info-wrapper + TRIGGER_DELAY запас
 * 3. Даём блоку position: sticky и top = -(пройденное расстояние прокрутки)
 */

(function () {
    'use strict';

    const MIN_WIDTH = 990;
    const TRIGGER_DELAY = 50;   // Запас (px)

    let infoWrapper = null;
    let infoContainer = null;
    let initialOffsetTop = 0;       // Точка триггера (теперь от НИЗА .product__info-wrapper)
    let containerOffsetTop = 0;     // Для top (от .product__info-container) — сейчас не используется
    let isStickyApplied = false;
    let isActive = false;

    function init() {
        infoWrapper = document.querySelector('.product__info-wrapper');
        infoContainer = document.querySelector('.product__info-container');

        if (!infoWrapper) {
            console.log('Sticky Scroll: .product__info-wrapper not found');
            return;
        }

        if (!infoContainer) {
            console.log('Sticky Scroll: .product__info-container not found');
            return;
        }

        calculateOffsets();
        checkViewport();

        window.addEventListener('resize', onResize);
        window.addEventListener('scroll', onScroll, { passive: true });
    }

    function calculateOffsets() {
        if (!infoWrapper || !infoContainer) return;

        // ВАЖНО: берём НИЗ .product__info-wrapper (а не верх) для точки триггера
        const wrapperRect = infoWrapper.getBoundingClientRect();
        initialOffsetTop = wrapperRect.bottom + window.scrollY;

        // Расстояние от начала страницы до .product__info-container (для top, если понадобится)
        const containerRect = infoContainer.getBoundingClientRect();
        containerOffsetTop = containerRect.top + window.scrollY;
    }

    function checkViewport() {
        isActive = window.innerWidth >= MIN_WIDTH;

        if (!isActive) {
            removeStyles();
            isStickyApplied = false;
        }
    }

    function onResize() {
        checkViewport();
        if (isActive && !isStickyApplied) {
            calculateOffsets();
        }
    }

    function onScroll() {
        if (!isActive || !infoWrapper) return;

        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const viewportBottom = scrollY + viewportHeight;

        // Условие: низ viewport касается НИЗА wrapper + TRIGGER_DELAY
        const triggerPoint = initialOffsetTop + TRIGGER_DELAY;

        if (viewportBottom >= triggerPoint && !isStickyApplied) {
            applySticky();
        }
    }

    function applySticky() {
        if (!infoWrapper || isStickyApplied) return;

        const scrollY = window.scrollY;
        const stickyTop = -scrollY;

        infoWrapper.style.position = 'sticky';
        infoWrapper.style.top = stickyTop + 'px';

        isStickyApplied = true;

        console.log('Sticky applied. Top:', stickyTop + 'px', 'ScrollY:', scrollY);
    }

    function removeStyles() {
        if (!infoWrapper) return;

        infoWrapper.style.position = '';
        infoWrapper.style.top = '';
        isStickyApplied = false;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
